//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from '../../../src/lib/date';

export default {
    name: "coupon",
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            list: [],
            memberLevel: -1,
            saving: false
        }
    },
    methods: {
        getCoupons(mId) {
            var page = {
                maxResultCount: 30,
                skipCount: 0,
                status: 0,
                channelType: 3,
                memberId: mId
            };
            abp.ajax.post('/api/services/app/Birthday/SearchBirthdayNotices', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
            })
        },
        sendCoupon(item) {
            var mid = localStorage.getItem('MemberId');
            if (!mid || mid == null || mid == undefined) {
                return;
            }
            var params = {
                userId: parseInt(mid),
                couponId: item.couponId,
                status: 1,
                receiveTime: new Date(),
                source: item.channelType,
                sourceId: item.id
            };
            // console.log(item);
            // console.log(params);
            // return;
            this.saving = true;
            abp.ajax.post('/api/services/app/Coupon/SaveCouponByNotice', params).then(res => {
                this.$toast.success('领取成功');
                this.getCoupons(parseInt(mid));
            }).finally(() => {
                this.saving = false;
            })
        },
        async getMyMember() {
            var vm = this;
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                var member = {};
                member = vm.$store.state.member.memberInfo;
                if (member && parseInt(member.id) > 0) {
                    this.getCoupons(parseInt(member.id))
                }

            });
        },
    },
    created() {
        this.getMyMember();
        // this.getCoupons();

    }
}
